import { Component, OnInit, Input } from '@angular/core';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// own feature
import { IBreadcrumbItem } from './model/breadcrumb.interface';
import { breadcrumbSetSelectedCrumb } from './store/actions';

@Component({
   selector: 'app-breadcrumb',
   templateUrl: './breadcrumb.component.html',
   styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

   @Input() public disableLink: boolean;
   @Input('breadcrumbs') public breadcrumbs: IBreadcrumbItem = null;

   constructor(
      private _store: NgRedux<IAppState>,
   ) { }

   ngOnInit() {
   }

   public onActivateLink(index: number) {
      // sanity
      if (!this._store || !this.breadcrumbs) { return; }

      this._store.dispatch(breadcrumbSetSelectedCrumb(this.breadcrumbs[index], 0));
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/breadcrumb/breadcrumb.component.ts